import React, { useState } from "react";
import axios from "axios";
import { Formik, Form, Field } from "formik";

// Updated pricing for all 50 states
const STATE_PRICING: Record<string, { service: number; state: number; total: number }> = {
  AL: { service: 398, state: 0, total: 398 },
  AK: { service: 199, state: 0, total: 199 },
  AZ: { service: 199, state: 0, total: 199 },
  AR: { service: 398, state: 0, total: 398 },
  CA: { service: 199, state: 0, total: 199 },
  CO: { service: 398, state: 0, total: 398 },
  CT: { service: 497, state: 0, total: 497 },
  DE: { service: 398, state: 0, total: 398 },
  DC: { service: 398, state: 0, total: 398 },
  FL: { service: 199, state: 0, total: 199 },
  GA: { service: 398, state: 0, total: 398 },
  HI: { service: 398, state: 0, total: 398 },
  ID: { service: 199, state: 0, total: 199 },
  IL: { service: 199, state: 0, total: 199 },
  IN: { service: 398, state: 0, total: 398 },
  IA: { service: 398, state: 0, total: 398 },
  KS: { service: 398, state: 0, total: 398 },
  KY: { service: 398, state: 0, total: 398 },
  LA: { service: 398, state: 0, total: 398 },
  ME: { service: 497, state: 0, total: 497 },
  MD: { service: 398, state: 0, total: 398 },
  MA: { service: 398, state: 0, total: 398 },
  MI: { service: 199, state: 0, total: 199 },
  MN: { service: 398, state: 0, total: 398 },
  MS: { service: 398, state: 0, total: 398 },
  MO: { service: 398, state: 0, total: 398 },
  MT: { service: 398, state: 0, total: 398 },
  NE: { service: 398, state: 0, total: 398 },
  NV: { service: 199, state: 10, total: 209 },
  NH: { service: 199, state: 0, total: 199 },
  NJ: { service: 199, state: 0, total: 199 },
  NM: { service: 398, state: 0, total: 398 },
  NY: { service: 199, state: 0, total: 199 },
  NC: { service: 398, state: 0, total: 398 },
  ND: { service: 398, state: 0, total: 398 },
  OH: { service: 398, state: 0, total: 398 },
  OK: { service: 398, state: 0, total: 398 },
  OR: { service: 199, state: 0, total: 199 },
  PA: { service: 398, state: 0, total: 398 },
  RI: { service: 199, state: 0, total: 199 },
  SC: { service: 398, state: 0, total: 398 },
  SD: { service: 199, state: 0, total: 199 },
  TN: { service: 199, state: 0, total: 199 },
  TX: { service: 199, state: 0, total: 199 },
  UT: { service: 398, state: 0, total: 398 },
  VT: { service: 398, state: 0, total: 398 },
  VA: { service: 398, state: 0, total: 398 },
  WA: { service: 398, state: 50, total: 448 },
  WV: { service: 199, state: 0, total: 199 },
  WI: { service: 398, state: 20, total: 418 },
  WY: { service: 199, state: 0, total: 199 },
};

const US_STATES = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];

export const TaxRegistrationForm = () => {
  const [form, setForm] = useState<any>({
    state: "CA",
    subtotal: STATE_PRICING["CA"].service,
    stateFee: STATE_PRICING["CA"].state,
    totalPrice: STATE_PRICING["CA"].total,
    // Account Info
    ownerFirstName: "",
    ownerLastName: "",
    ownerMiddleInitial: "",
    ownerPhone: "",
    ownerEmail: "",
    ownerSuffix: "",
    contactFirstName: "",
    contactLastName: "",
    contactMiddleInitial: "",
    contactPhone: "",
    contactEmail: "",
    contactSuffix: "",
    companyStreet1: "",
    companyStreet2: "",
    companyCity: "",
    companyState: "",
    companyZipCode: "",
    companyCounty: "United States",
    // Business Details
    entityType: "",
    category: "",
    businessName: "",
    ein: "",
    dbaName: "",
    description: "",
    naicsCode: "",
    incorporationState: "",
    formationDate: "",
    primaryStreet1: "",
    primaryStreet2: "",
    primaryCity: "",
    primaryState: "",
    primaryZipCode: "",
    primaryCounty: "United States",
    mailingStreet1: "",
    mailingStreet2: "",
    mailingCity: "",
    mailingState: "",
    mailingZipCode: "",
    mailingCounty: "",
    fiscalYearEnd: "",
    booksStreet1: "",
    booksStreet2: "",
    booksCity: "",
    booksState: "",
    booksZipCode: "",
    booksCounty: "",
    booksMaintainer: "",
    noticeStreet1: "",
    noticeStreet2: "",
    noticeCity: "",
    noticeState: "",
    noticeZipCode: "",
    noticeCounty: "",
    noticeContactName: "",
    haveEmployeesOutsideOfUS: false,
    hasLegalEntityChanged: false,
    llcIsMemberManaged: false,
    llcIsCompanyTaxedAsSCorp: false,
    llcIsSingleMember: false,
    // State Info
    businessAddressStreet1: "",
    businessAddressStreet2: "",
    businessAddressCity: "",
    businessAddressState: "",
    businessAddressZipCode: "",
    businessAddressCounty: "",
    buildingType: "",
    employeesStartedWorkingInStateDate: "",
    firstPayrollInStateDate: "",
    firstPayrollAmount: "",
    numberOfEmployeesInState: "",
    numberOfEmployeesAtBusinessAddress: "",
    exceededWagesThresholdDate: "",
    // Responsible Party (only one for now)
    respType: "individual",
    respTitle: "",
    respFirstName: "",
    respMiddleInitial: "",
    respLastName: "",
    respSuffix: "",
    respEmail: "",
    respPhone: "",
    respOwnershipPercentage: "",
    respDateOfBirth: "",
    respIdType: "",
    respIdNumber: "",
    respAddressStreet1: "",
    respAddressStreet2: "",
    respAddressCity: "",
    respAddressState: "",
    respAddressZipCode: "",
    respAddressCounty: "",
    respIsSignatory: false,
    respCompanyName: "",
    respCommercialEmail: "",
    respCommercialPhone: "",
    respEin: ""
  });

  // Update form state and price on state change
  const handleStateChange = (e: React.ChangeEvent<HTMLSelectElement>, setFieldValue: any, values: any) => {
    const state = e.target.value;
    // Only update the pricing fields, do not reset the rest of the form
    setFieldValue('state', state);
    setFieldValue('subtotal', STATE_PRICING[state]?.service || 0);
    setFieldValue('stateFee', STATE_PRICING[state]?.state || 0);
    setFieldValue('totalPrice', STATE_PRICING[state]?.total || 0);
  };

  // Alert state for success/error messages
  const [alertMsg, setAlertMsg] = useState<{ open: boolean; type: "success" | "error"; content: string }>({ open: false, type: "success", content: "" });
  const [orderPlaced, setOrderPlaced] = useState<string | null>(null);

  const initialValues = form;

  const handleSubmit = async (values: any, { setSubmitting, resetForm }: any) => {
    setAlertMsg({ open: false, type: "success", content: "" });
    try {
      // Map form values to API orderBody structure
      const orderBody = {
        orderFilingType: "Standard", // or get from form if needed
        apiUserPid: values.apiUserPid || "1", // or get from context/auth
        pcid: "1001", // or get from context/auth
        accountInfo: {
          owner: {
            firstName: values.ownerFirstName,
            lastName: values.ownerLastName,
            middleInitial: values.ownerMiddleInitial,
            phone: values.ownerPhone,
            email: values.ownerEmail,
            suffix: values.ownerSuffix,
          },
          contact: {
            firstName: values.contactFirstName,
            lastName: values.contactLastName,
            middleInitial: values.contactMiddleInitial,
            phone: values.contactPhone,
            email: values.contactEmail,
            suffix: values.contactSuffix,
          },
          companyAddress: {
            street1: values.companyStreet1,
            street2: values.companyStreet2,
            city: values.companyCity,
            state: values.companyState,
            zipCode: values.companyZipCode,
            county: values.companyCounty,
          },
        },
        businessDetails: {
          entityType: values.entityType,
          category: values.category,
          name: values.businessName,
          ein: values.ein,
          dbaName: values.dbaName,
          description: values.description,
          naicsCode: Number(values.naicsCode) || 0,
          incorporationState: values.incorporationState,
          formationDate: values.formationDate,
          primaryAddress: {
            street1: values.primaryStreet1,
            street2: values.primaryStreet2,
            city: values.primaryCity,
            state: values.primaryState,
            zipCode: values.primaryZipCode,
            county: values.primaryCounty,
          },
          mailingAddress: {
            street1: values.mailingStreet1,
            street2: values.mailingStreet2,
            city: values.mailingCity,
            state: values.mailingState,
            zipCode: values.mailingZipCode,
            county: values.mailingCounty,
          },
          fiscalYearEnd: values.fiscalYearEnd,
          booksOfRecordAddress: {
            street1: values.booksStreet1,
            street2: values.booksStreet2,
            city: values.booksCity,
            state: values.booksState,
            zipCode: values.booksZipCode,
            county: values.booksCounty,
          },
          booksOfRecordMaintainer: values.booksMaintainer,
          noticeOfPotentialChangesAddress: {
            street1: values.noticeStreet1,
            street2: values.noticeStreet2,
            city: values.noticeCity,
            state: values.noticeState,
            zipCode: values.noticeZipCode,
            county: values.noticeCounty,
          },
          noticeOfPotentialChangesContactName: values.noticeContactName,
          haveEmployeesOutsideOfUS: !!values.haveEmployeesOutsideOfUS,
          hasLegalEntityChanged: !!values.hasLegalEntityChanged,
          llcInfo: {
            isMemberManaged: !!values.llcIsMemberManaged,
            isCompanyTaxedAsSCorp: !!values.llcIsCompanyTaxedAsSCorp,
            isSingleMember: !!values.llcIsSingleMember,
          },
        },
        stateInfo: {
          state: values.state,
          totalPrice: String(values.totalPrice),
          businessAddress: {
            street1: values.businessAddressStreet1,
            street2: values.businessAddressStreet2,
            city: values.businessAddressCity,
            state: values.businessAddressState,
            zipCode: values.businessAddressZipCode,
            county: values.businessAddressCounty,
          },
          buildingType: values.buildingType,
          employeesStartedWorkingInStateDate: values.employeesStartedWorkingInStateDate,
          firstPayrollInStateDate: values.firstPayrollInStateDate,
          firstPayrollAmount: Number(values.firstPayrollAmount) || 0,
          numberOfEmployeesInState: Number(values.numberOfEmployeesInState) || 0,
          numberOfEmployeesAtBusinessAddress: Number(values.numberOfEmployeesAtBusinessAddress) || 0,
          exceededWagesThresholdDate: values.exceededWagesThresholdDate,
        },
        responsibleParties: [
          {
            type: values.respType,
            title: values.respTitle,
            legalIndividualInfo: {
              firstName: values.respFirstName,
              middleInitial: values.respMiddleInitial,
              lastName: values.respLastName,
              suffix: values.respSuffix,
              email: values.respEmail,
              phone: values.respPhone,
            },
            ownershipPercentage: Number(values.respOwnershipPercentage) || 0,
            dateOfBirth: values.respDateOfBirth,
            idType: values.respIdType,
            idNumber: values.respIdNumber,
            address: {
              street1: values.respAddressStreet1,
              street2: values.respAddressStreet2,
              city: values.respAddressCity,
              state: values.respAddressState,
              zipCode: values.respAddressZipCode,
              county: values.respAddressCounty,
            },
            isSignatory: !!values.respIsSignatory,
            legalCommercialInfo: {
              companyName: values.respCompanyName,
              email: values.respCommercialEmail,
              phone: values.respCommercialPhone,
            },
            ein: values.respEin,
          },
        ],
      };
      const response = await axios.post(
        "/companyFormation/createTaxRegistrationOrder",
        { orderBody },
        { withCredentials: true }
      );
      if (response && response.data && response.data.status === 'success') {
        setOrderPlaced(response.data.orderGuid || '');
        setAlertMsg({ open: true, type: 'success', content: 'Form submitted successfully! Order ID: ' + (response.data.orderGuid || '') });
        resetForm();
      } else {
        setAlertMsg({ open: true, type: 'error', content: response.data?.error || 'Failed to create order' });
      }
    } catch (error: any) {
      setAlertMsg({ open: true, type: 'error', content: error?.response?.data?.error || error?.message || 'Submission failed' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize={false}>
      {({ isSubmitting, values, handleChange, setFieldValue, resetForm }) => (
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          {/* Alert message */}
          {alertMsg.open && (
            <div className={`alert alert-${alertMsg.type === 'success' ? 'success' : 'danger'} alert-dismissible fade show`} role="alert" style={{ fontWeight: 'bold' }}>
              {alertMsg.content}
              <button type="button" className="btn-close" aria-label="Close" onClick={() => setAlertMsg({ ...alertMsg, open: false })}></button>
            </div>
          )}
          {orderPlaced ? (
            <div className="text-center py-5">
              <div style={{ fontSize: 72, color: '#28a745' }}>
                <i className="bx bx-check-circle"></i>
              </div>
              <h2 className="mt-3 mb-2">Order Placed!</h2>
              <div className="mb-2">Your order has been placed successfully.</div>
              <div className="fw-bold">Order ID: {orderPlaced}</div>
            </div>
          ) : (
            <Form className="p-4">
              <h3 className="mb-4">Employer Tax Registration</h3>
              {/* --- Account Info Section --- */}
              <hr className="my-4" />
              <h5 className="mt-4">Account Info</h5>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Owner First Name <span className="text-danger">*</span></label>
                  <Field className="form-control" name="ownerFirstName" placeholder="e.g. John" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Owner Last Name <span className="text-danger">*</span></label>
                  <Field className="form-control" name="ownerLastName" placeholder="e.g. Doe" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Owner Middle Initial <span className="text-muted">(optional)</span></label>
                  <Field className="form-control" name="ownerMiddleInitial" placeholder="e.g. A" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Owner Phone <span className="text-danger">*</span></label>
                  <Field className="form-control" name="ownerPhone" placeholder="e.g. 555-123-4567" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Owner Email <span className="text-danger">*</span></label>
                  <Field className="form-control" name="ownerEmail" placeholder="e.g. john@example.com" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Owner Suffix <span className="text-muted">(optional)</span></label>
                  <Field className="form-control" name="ownerSuffix" placeholder="e.g. Jr, Sr, III" />
                </div>
              </div>
              <hr className="my-4" />
              <h6 className="mt-3">Contact Info</h6>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Contact First Name <span className="text-danger">*</span></label>
                  <Field className="form-control" name="contactFirstName" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Contact Last Name <span className="text-danger">*</span></label>
                  <Field className="form-control" name="contactLastName" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Contact Middle Initial <span className="text-muted">(optional)</span></label>
                  <Field className="form-control" name="contactMiddleInitial" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Contact Phone <span className="text-danger">*</span></label>
                  <Field className="form-control" name="contactPhone" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Contact Email <span className="text-danger">*</span></label>
                  <Field className="form-control" name="contactEmail" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Contact Suffix <span className="text-muted">(optional)</span></label>
                  <Field className="form-control" name="contactSuffix" />
                </div>
              </div>
              <hr className="my-4" />
              <h6 className="mt-3">Company Address</h6>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Street 1 <span className="text-danger">*</span></label>
                  <Field className="form-control" name="companyStreet1" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Street 2 <span className="text-muted">(optional)</span></label>
                  <Field className="form-control" name="companyStreet2" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">City <span className="text-danger">*</span></label>
                  <Field className="form-control" name="companyCity" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">State <span className="text-danger">*</span> <span className="text-muted">(Ex. "CA")</span></label>
                  <Field as="select" className="form-control" name="companyState">
                    <option value="">Select state</option>
                    {US_STATES.map(s => (
                      <option key={s.value} value={s.value}>{s.label}</option>
                    ))}
                  </Field>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Zip Code <span className="text-danger">*</span></label>
                  <Field className="form-control" name="companyZipCode" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">County <span className="text-muted"></span></label>
                  <Field className="form-control" name="companyCounty" />
                </div>
              </div>
              <hr className="my-4" />
              {/* --- Business Details Section --- */}
              <h5 className="mt-4">Business Details</h5>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Entity Type <span className="text-danger">*</span></label>
                  <Field as="select" className="form-control" name="entityType">
                    <option value="">Select entity type</option>
                    <option value="C-Corporation">C-Corporation</option>
                    <option value="S-Corporation">S-Corporation</option>
                    <option value="Sole Proprietorship">Sole Proprietorship</option>
                    <option value="Limited Liability Company (LLC)">Limited Liability Company (LLC)</option>
                    <option value="LLP">LLP</option>
                    <option value="Limited partnership">Limited partnership</option>
                    <option value="Co-ownership">Co-ownership</option>
                    <option value="Association">Association</option>
                    <option value="Trusteeship">Trusteeship</option>
                    <option value="General partnership">General partnership</option>
                    <option value="Joint venture">Joint venture</option>
                    <option value="Non-Profit Corporation">Non-Profit Corporation</option>
                  </Field>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Category</label>
                  <Field className="form-control" name="category" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Business Name</label>
                  <Field className="form-control" name="businessName" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">EIN</label>
                  <Field type="number" className="form-control" name="ein" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">DBA Name <span className="text-muted">(optional)</span></label>
                  <Field className="form-control" name="dbaName" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Description</label>
                  <Field className="form-control" name="description" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">NAICS Code</label>
                  <Field type="number" className="form-control" name="naicsCode" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Incorporation State</label>
                  <Field as="select" className="form-control" name="incorporationState">
                    <option value="">Select state</option>
                    {US_STATES.map(s => (
                      <option key={s.value} value={s.value}>{s.label}</option>
                    ))}
                  </Field>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Formation Date</label>
                  <Field type="date" className="form-control" name="formationDate" placeholder="MM/DD/YYYY" />
                </div>
                {/* ...repeat for all other businessDetails fields... */}
              </div>
              <hr className="my-4" />
              {/* --- State Info Section --- */}
              <h5 className="mt-4">State Info</h5>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">State</label>
                  <Field as="select" className="form-control" name="state"
                    onChange={e => handleStateChange(e, setFieldValue, values)}>
                    {US_STATES.map(s => (
                      <option key={s.value} value={s.value}>{s.label}</option>
                    ))}
                  </Field>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Business Address Street 1</label>
                  <Field className="form-control" name="businessAddressStreet1" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Business Address Street 2</label>
                  <Field className="form-control" name="businessAddressStreet2" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Business Address City</label>
                  <Field className="form-control" name="businessAddressCity" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Business Address State</label>
                  <Field as="select" className="form-control" name="businessAddressState">
                    <option value="">Select state</option>
                    {US_STATES.map(s => (
                      <option key={s.value} value={s.value}>{s.label}</option>
                    ))}
                  </Field>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Business Address Zip Code</label>
                  <Field className="form-control" name="businessAddressZipCode" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Business Address County</label>
                  <Field className="form-control" name="businessAddressCounty" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Building Type</label>
                  <Field as="select" className="form-control" name="buildingType">
                    <option value="">Select building type</option>
                    <option value="Home Office">Home Office</option>
                    <option value="Business Office">Business Office</option>
                    <option value="Service Center">Service Center</option>
                    <option value="Warehouse">Warehouse</option>
                  </Field>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Employees Started Working In State Date</label>
                  <Field type="date" className="form-control" name="employeesStartedWorkingInStateDate" placeholder="MM/DD/YYYY" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">First Payroll In State Date</label>
                  <Field type="date" className="form-control" name="firstPayrollInStateDate" placeholder="MM/DD/YYYY" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">First Payroll Amount</label>
                  <Field type="number" className="form-control" name="firstPayrollAmount" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Number Of Employees In State</label>
                  <Field type="number" className="form-control" name="numberOfEmployeesInState" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Number Of Employees At Business Address</label>
                  <Field type="number" className="form-control" name="numberOfEmployeesAtBusinessAddress" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Exceeded Wages Threshold Date</label>
                  <Field type="date" className="form-control" name="exceededWagesThresholdDate" placeholder="MM/DD/YYYY" />
                </div>
              </div>
              <hr className="my-4" />
              {/* --- Responsible Party Section --- */}
              <h5 className="mt-4">Responsible Party</h5>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Type</label>
                  <Field className="form-control" name="respType" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Title</label>
                  <Field className="form-control" name="respTitle" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">First Name</label>
                  <Field className="form-control" name="respFirstName" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Middle Initial</label>
                  <Field className="form-control" name="respMiddleInitial" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Last Name</label>
                  <Field className="form-control" name="respLastName" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Suffix</label>
                  <Field className="form-control" name="respSuffix" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Email</label>
                  <Field className="form-control" name="respEmail" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Phone</label>
                  <Field className="form-control" name="respPhone" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Ownership Percentage</label>
                  <Field type="number" className="form-control" name="respOwnershipPercentage" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Date Of Birth</label>
                  <Field type="date" className="form-control" name="respDateOfBirth" placeholder="MM/DD/YYYY" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">ID Type</label>
                  <Field className="form-control" name="respIdType" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">ID Number</label>
                  <Field className="form-control" name="respIdNumber" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Address Street 1</label>
                  <Field className="form-control" name="respAddressStreet1" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Address Street 2</label>
                  <Field className="form-control" name="respAddressStreet2" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Address City</label>
                  <Field className="form-control" name="respAddressCity" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Address State</label>
                  <Field as="select" className="form-control" name="respAddressState">
                    <option value="">Select state</option>
                    {US_STATES.map(s => (
                      <option key={s.value} value={s.value}>{s.label}</option>
                    ))}
                  </Field>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Address Zip Code</label>
                  <Field className="form-control" name="respAddressZipCode" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Address County</label>
                  <Field className="form-control" name="respAddressCounty" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Is Signatory?</label>
                  <Field
                    className="form-check-input ms-2"
                    type="checkbox"
                    name="respIsSignatory"
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Company Name</label>
                  <Field className="form-control" name="respCompanyName" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Commercial Email</label>
                  <Field className="form-control" name="respCommercialEmail" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Commercial Phone</label>
                  <Field className="form-control" name="respCommercialPhone" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">EIN</label>
                  <Field className="form-control" name="respEin" />
                </div>
              </div>
              {/* Invoice-style total price summary at the bottom right */}
              <div className="d-flex flex-row-reverse mt-5">
                <div style={{ minWidth: 320 }}>
                  <div className="card shadow-sm p-3" style={{ background: '#f8f9fa' }}>
                    <h5 className="mb-3">Order Summary</h5>
                    <div className="d-flex justify-content-between mb-2">
                      <span>Subtotal (Service Fee)</span>
                      <span>${values.subtotal ? values.subtotal.toFixed(2) : '0.00'}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <span>State Fee</span>
                      <span>${values.stateFee ? values.stateFee.toFixed(2) : '0.00'}</span>
                    </div>
                    <hr />
                    <div className="d-flex justify-content-between fw-bold">
                      <span>Total</span>
                      <span>${values.totalPrice ? values.totalPrice.toFixed(2) : '0.00'}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-row-reverse mt-3">
                <button className="btn btn-primary" type="submit" disabled={isSubmitting}>
                  {isSubmitting ? "Submitting..." : "Submit Registration"}
                </button>
              </div>
            </Form>
          )}
        </div>
      )}
    </Formik>
  );
};
